var map = {
	"./accountManage.js": 78579,
	"./exchangeRecord.js": 70095,
	"./home.js": 29816,
	"./noToken.js": 46895,
	"./platformAbout.js": 57387,
	"./qualificationManage.js": 68198,
	"./registrationProcess.js": 29,
	"./sendPaper.js": 64483
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90097;